var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.image_items, function (item) {
      return _c("div", [
        _vm.isEmpty
          ? _c("span", [_vm._v("沒有圖片")])
          : _c("img", { attrs: { width: "auto", src: _vm.get_image(item) } }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }